module.exports = __webpack_public_path__ + "img/doc.7a36f6b8.svg";